import { render } from "./TopNews.vue?vue&type=template&id=5020a182&ts=true"
import script from "./TopNews.vue?vue&type=script&lang=ts"
export * from "./TopNews.vue?vue&type=script&lang=ts"

import "./TopNews.vue?vue&type=style&index=0&id=5020a182&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__